import type { ICentPrecisionMoney } from "@components/commerce/order/types";
import { CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { Text } from "@ecco/ui/text";
import { Money } from "@ecco/ui/money";
import type { SimpleMoneyData } from "@ecco/ui/use-money";
import type { FC } from "react";

export interface DeliveryFeeProps {
    price: ICentPrecisionMoney;
    locale: string;
}

export const DeliveryFee: FC<DeliveryFeeProps> = ({ price, locale }) => {
    const { get: getMicrocopy } = useMicrocopy();
    const freeText = getMicrocopy(CommonCMS.shared, CommonCMS.free);

    if (price.centAmount === 0.0) {
        return (
            <Text color="green.200" fontWeight="bold" as="span">
                {freeText}
            </Text>
        );
    }

    const transformedPrice: SimpleMoneyData = {
        centAmount: price.centAmount,
        currencyCode: price.currencyCode,
        fractionDigits: price.fractionDigits,
    };

    return (
        <Money
            data={transformedPrice}
            color="gray.500"
            fontWeight="bold"
            as="span"
            locale={locale}
        />
    );
};
